/* theme/assets/fm-product.js — Formula buy box (spec 2026-10-02 §5.3). State: FmBundleState (pure); cart: FmCart.
   Selecting a card is instant (no transition, as the reference). */
(() => {
  if (customElements.get('fm-product')) return;
  const qs = (s, el) => el.querySelector(s);
  const all = (s, el) => [...el.querySelectorAll(s)];
  class FmProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const json = (sel) => { const el = qs(sel, this); return el ? JSON.parse(el.textContent) : null; };
      this.product = json('[data-fm-product-json]');
      this.cfg = json('[data-fm-buy-config]') || {};
      this.state = { card: this.cfg.defaultCard, subscribe: false };
      all('[data-fm-card]', this).forEach((el) => {
        el.addEventListener('click', () => this.select(el.dataset.fmCard));
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.select(el.dataset.fmCard); } });
      });
      qs('[data-fm-subscribe]', this)?.addEventListener('change', (e) => { this.state.subscribe = e.target.checked; this.update(); });
      qs('[data-fm-atc]', this)?.addEventListener('click', (e) => { e.preventDefault(); this.add(); });
      all('[data-fm-addon-inline]', this).forEach((btn) => btn.addEventListener('click', (e) => { e.preventDefault(); this.addAddon(btn); }));
      all('.fm-videos__slide', this).forEach((slide) => {
        const video = qs('video', slide), play = qs('.fm-videos__play', slide);
        if (!video || !play) return;
        play.addEventListener('click', () => { if (video.paused) { video.play(); play.hidden = true; } else video.pause(); });
        video.addEventListener('click', () => { video.pause(); play.hidden = false; });
      });
      this.update();
    }
    select(id) { this.state.card = id; this.update(); }
    view() {
      return window.FmBundleState.compute({
        variants: this.product?.variants || [], variantId: this.cfg.variantId, cards: this.cfg.cards || [], state: this.state,
        subscriptionEnabled: this.cfg.subscriptions, moneyFormat: document.body.dataset.moneyFormat, defaultCard: this.cfg.defaultCard,
      });
    }
    update() {
      if (!this.product) return;   // placeholder buy box: nothing to compute
      const v = this.view();
      this.v = v;
      v.cards.forEach((c) => {
        const el = qs(`[data-fm-card="${CSS.escape(String(c.id))}"]`, this);
        if (!el) return;
        el.classList.toggle('is-selected', c.selected);
        el.setAttribute('aria-checked', String(c.selected));
        const set = (sel, text) => { const x = qs(sel, el); if (x) { x.textContent = text; x.hidden = !text; } };
        set('[data-fm-card-price]', c.priceText);
        set('[data-fm-card-compare]', c.compareText);
        set('[data-fm-card-unit]', c.perUnitText ? String(this.cfg.unitLabel || '{price}').replace('{price}', c.perUnitText) : '');
      });
      all('[data-fm-price]', this).forEach((el) => { el.textContent = v.priceText; });
      all('[data-fm-compare]', this).forEach((el) => { el.textContent = v.compareText; el.hidden = !v.compareText; });
      all('[data-fm-percent-pill]', this).forEach((el) => { el.textContent = String(el.dataset.pattern || '').replace('{percent}', String(v.percent)); el.hidden = !v.percent; });
      // Ritmovio spec 2026-10-04 §5.3: the ships pill and the stock bar follow the selected format.
      all('[data-fm-ships]', this).forEach((el) => el.classList.toggle('is-digital', !v.shipping));
      all('[data-fm-stock]', this).forEach((el) => {
        const pct = v.variant ? window.FmBundleState.stockPercent(el.dataset.fmStock, v.variant.id) : null;
        el.hidden = pct === null;
        if (pct === null) return;
        const fill = qs('[data-fm-stock-fill]', el);
        if (fill) fill.style.width = `${pct}%`;
        const n = qs('[data-fm-stock-pct]', el);
        if (n) n.textContent = String(pct);
      });
      const atc = qs('[data-fm-atc]', this);
      if (atc) {
        atc.disabled = !v.available;
        const label = qs('[data-fm-atc-label]', atc);
        if (label) label.textContent = v.available ? this.cfg.addLabel : this.cfg.soldOutLabel;
      }
      // Spec §5.3: on a product page with several variants the URL follows the selection (?variant=).
      if (v.variant && (this.product.variants || []).length > 1 && document.body.classList.contains('fm--product')) {
        const url = new URL(location.href);
        if (url.searchParams.get('variant') !== String(v.variant.id)) { url.searchParams.set('variant', String(v.variant.id)); history.replaceState(history.state, '', url); }
      }
      this.dispatchEvent(new CustomEvent('fm:variant-change', { detail: v, bubbles: true }));
    }
    async add() {
      if (!this.v?.available) return;
      const atc = qs('[data-fm-atc]', this);
      const err = qs('[data-fm-atc-error]', this);
      if (err) err.hidden = true;
      atc.classList.add('is-loading');
      atc.setAttribute('aria-busy', 'true');
      try { await window.FmCart.add(this.v.items); }
      catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
      finally { atc.classList.remove('is-loading'); atc.removeAttribute('aria-busy'); }
    }
    async addAddon(btn) {
      const err = qs('[data-fm-atc-error]', this);
      btn.classList.add('is-loading');
      try { await window.FmCart.add([{ id: Number(btn.dataset.fmAddonInline), quantity: 1 }]); }
      catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
      finally { btn.classList.remove('is-loading'); }
    }
  }
  customElements.define('fm-product', FmProduct);
})();
